import * as helper from '@/store/helpers'
import { defineStore } from 'pinia'

export const useRaaiMembersStore = defineStore('raaiMembers', {
    state() {
        return {
            allMembers: [],
            allRegionalBranches: []
        }
    },
    actions: {
        async getRaaiMembers() {
            const countOfRaiiMembers = await helper.api('GET', '/users/count', {
                is_raai_members: true
            })
            this.allMembers = await helper.api('GET', '/users', {
                start: 0,
                end: countOfRaiiMembers,
                is_raai_members: true
            })
        },

        async getRegionalBranches() {
            this.allRegionalBranches = await helper.api(
                'GET',
                '/raai_members/regions',
                {}
            )
        }
    },
    getters: {
        formatRaaiMembers(state) {
            return state.allMembers
                .map((elem) => {
                    return {
                        fullName: `${elem.surname} ${elem.name} ${elem.patronymic}`,
                        regionalBranch:
                            elem.raai_member_region !== null
                                ? elem.raai_member_region.name
                                : '',
                        showProfile: elem.show_personality,
                        isHidden: elem.is_hidden_info,
                        userId: elem.id
                    }
                })
                .sort((a, b) => a.fullName.localeCompare(b.fullName))
        },

        formatRegionalBranches(state) {
            return state.allRegionalBranches
                .map((elem) => {
                    return {
                        regionalBranch: elem.name,
                        chairman:
                            elem.chairman_full_name !== null
                                ? elem.chairman_full_name
                                : '',
                        email:
                            elem.chairman_email !== null
                                ? elem.chairman_email
                                : ''
                    }
                })
                .sort((a, b) =>
                    a.regionalBranch.localeCompare(b.regionalBranch)
                )
        }
    }
})
